import * as React from "react";
import * as Ons from "react-onsenui";
import { isLoading } from "../Loading";
import { ChatRoomId } from "../messages/ObjectIds";
import { STRINGS } from "../strings";
import { AppAgenciesState } from "../system/AppState/AppAgenciesState";
import { Visit } from "../system/AppState/AppVisitsState";
import { AppChatState, ChatSystemStrategies } from "../system/AppState/ChatState";
import { translate } from "../translate";
import { List } from "../utils/List";
import { ChatsList } from "./ChatsList";

export interface ChatsListContainerProps {
  chats: AppChatState;
  chatSystemStrategies: ChatSystemStrategies;
  agencies: AppAgenciesState;
  visits: List<Visit>;
  onChatRoomClick: (chatRoomId: ChatRoomId) => void;
  onPlaceHolderBtnClick: () => void;
}

export class ChatsListContainerState {}

/**
 * Shows a <ChatsList>, or a loading indicator, or an appropriate placeholder if there are no chats
 */
export class ChatsListContainer extends React.Component<
  ChatsListContainerProps,
  ChatsListContainerState
> {
  constructor(props: ChatsListContainerProps) {
    super(props);

    this.state = {};
  }

  render(): JSX.Element {
    const chats = AppChatState.getLatestChats(this.props.chats, this.props.chatSystemStrategies);

    if (isLoading(chats)) {
      return (
        <div className="ChatsListContainer__root">
          <Ons.ProgressCircular indeterminate={true} />
        </div>
      );
    }

    if (chats.length() === 0) {
      return (
        <div className="ChatsListContainer__root">
          <div className="ChatsScreenContainer__emptyPlaceHolder">
            <div className="ChatsScreenContainer__emptyPlaceHolderImg" />
            <div className="ChatsScreenContainer__emptyPlaceHolderText">
              {translate(STRINGS.THERE_ARE_NO_AGENCIES_YET)}
            </div>
            <button
              className="ChatsScreenContainer__emptyPlaceholderAddAgencyButton"
              onClick={() => this.props.onPlaceHolderBtnClick()}
            >
              {translate(STRINGS.REQUEST_AGENCIES_MEMBERSHIP)}
            </button>
          </div>
        </div>
      );
    }
    return (
      <div className="ChatsListContainerContainer__root">
        <ChatsList
          chats={chats}
          agencies={this.props.agencies}
          visits={this.props.visits}
          onChatRoomClick={this.props.onChatRoomClick}
        />
      </div>
    );
  }
}
